import { ChatAPI } from '@guuru/chat-web';
import { PRIORITIES } from '@guuru/expert-common';
import createAndTransferChat from '../../commands/createAndTransferChat';

const isProductAdvise = (automationBehavior) =>
  automationBehavior?.label === 'get_info_product_advise';

const hasAlreadyGuurusOnlyPriority = () => {
  const priority = ChatAPI.storeRetrieveChatPriority();
  return priority === PRIORITIES.guurusOnly.value;
};

const handleSmartRouting = (partnerId, automationBehavior) => {
  let priority = automationBehavior?.subscriptionPriority;
  if (hasAlreadyGuurusOnlyPriority() && isProductAdvise(automationBehavior)) {
    priority = PRIORITIES.guurusOnly.value;
  }
  ChatAPI.storeChatPriority(priority);
  return { goToNextStep: true };
};

const handleRouting = async (automationBehavior, { partnerId }) => {
  if (automationBehavior?.subscriptionPriority === 'transfer') {
    await createAndTransferChat(partnerId, {
      targetId: automationBehavior?.subscriptionTarget,
      handover: automationBehavior.label === 'form_fallback',
    });
    return { goToNextStep: false };
  }

  return handleSmartRouting(partnerId, automationBehavior);
};

export default handleRouting;
